export default __webpack_public_path__ + "static/media/resume.2ea78171.pdf";